// extracted by mini-css-extract-plugin
export var articleListWrapper = "index-module--article-list-wrapper--fKIA4";
export var infoArea = "index-module--info-area--o6vlg";
export var lede = "index-module--lede--mdNxy";
export var ledeWrapper = "index-module--lede-wrapper--oOzJy";
export var mainImageWrapper = "index-module--main-image-wrapper--CEoss";
export var root = "index-module--root--NCVTc";
export var showSeriesLinkWrapper = "index-module--show-series-link-wrapper--Sl4lB";
export var title = "index-module--title--HwsvC";
export var titleWrapper = "index-module--title-wrapper--T1rV+";